import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { RootState } from '@/state/store';

/** Navigates to /access-denied whenever a 403 sets the forbidden flag. */
export function AccessDeniedWatcher() {
  const forbidden = useSelector((s: RootState) => s.access.forbidden);
  const navigate = useNavigate();

  useEffect(() => {
    if (forbidden) navigate('/access-denied');
  }, [forbidden, navigate]);

  return null;
}
